<app-error-message header="You do not have permission to access this page."
                   [imageUrl]="'/images/permission-denied.svg'"
                   [subHeader]="subHeader"></app-error-message>

<ng-template #subHeader>
  <p>
    You are not authorized to view this content. Please contact your administrator or GAC <a class="underline"
       href="mailto: help@gac.com">support</a> if you believe you should have access to this page.
  </p>
</ng-template>